import service from '@/utils/request';

/**
 * @deprecated 获取风控渠道
 * @returns {AxiosPromise}
 */
export var getRiskList = function getRiskList() {
  return service({
    url: '/risk/getRiskList',
    method: 'get'
  });
};

/**
 * @deprecated 获取风控列表
 * @param data
 * @returns {AxiosPromise}
 */
export var riskList = function riskList(data) {
  return service({
    url: '/risk/riskList',
    method: 'post',
    data: data
  });
};

/**
 * @deprecated 添加风控渠道
 * @param data
 * @returns {AxiosPromise}
 */
export var addRiskOne = function addRiskOne(data) {
  return service({
    url: '/risk/addRiskOne',
    method: 'post',
    data: data
  });
};

/**
 * @deprecated 风控退款
 */
export var refundRisk = function refundRisk(data) {
  return service({
    url: '/risk/refund',
    method: 'post',
    data: data
  });
};